import { TilbyDatePipe } from "@tilby/tilby-ui-lib/pipes/tilby-date";
import { CustomerNameFilter, EInvoiceNumberFilter } from "src/app/shared/model/grid-custom-filter.model";
import { Sales } from "tilby-models";

export class SalesEInvoicesFe implements Partial<Sales> {
    e_invoice_number = new EInvoiceNumberFilter();
    customer_name = new CustomerNameFilter();
    final_amount = 0;
    closed_at = TilbyDatePipe.date({outputFormat:'date'});
    status = undefined;
}

export interface EInvoiceSyncStatus {
    status?: Record<string, number>;
}